import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6a8fb524&scoped=true&lang=html&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fb524",
  null
  
)

export default component.exports